import React, { memo } from "react";
import "./style.scss";
import { FormattedMessage } from "react-intl";

const Intro = ({ onDone }) => {
  const handlerOnDone = () => {
    window &&
      window.dataLayer &&
      window.dataLayer.push({ event: "startClick" });
    onDone && onDone();
  };

  return (
    <div className="DicesIntro">
      <div className="DicesIntro-Window">
        <div className="DicesIntro-Close" onClick={handlerOnDone}>
          <div />
        </div>
        <div>
          <p className="DicesIntro-Title">
            <FormattedMessage id="Intro.title" />
          </p>
          <p className="DicesIntro-Description">
            <FormattedMessage id="Intro.description" />
          </p>
        </div>
        <div className="DicesIntro-ImageSection">
          <div className="DicesIntro-ImageSection-Wrap">
            <div />
          </div>
        </div>
        <div className="DicesIntro-Button" onClick={handlerOnDone}>
          <FormattedMessage id="Intro.button" />
        </div>
      </div>
    </div>
  );
};

export default memo(Intro);
